/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageSend = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      d="M16 8a.609.609 0 0 0-.33-.535L.89.066C.427-.164-.106.244.018.742l1.353 5.833a.586.586 0 0 0 .533.462l7.558.73c.125.02.147.133.147.233 0 .101-.022.213-.147.234l-7.558.729a.587.587 0 0 0-.533.462L.018 15.258c-.124.498.41.907.872.676l14.78-7.398A.61.61 0 0 0 16 8"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

IconMessageSend.displayName = 'IconMessageSend';

IconMessageSend.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageSend);
IconMessageSend.displayName = 'IconMessageSend';
